module.exports = __webpack_public_path__ + "img/hotel-barriere-les-neiges-courchevel_0.b4a62daa.jpg";